<div class="modal fade" id="{{emailQuestionFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">E-mail Question</h6>
                <button type="button" class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-sm-12 mb-4 px-3 col-form-label-sm">
                    <div class="row">

                        <!-- User Selection -->
                        <div class="col-6">
                            <div class="d-flex flex-wrap mt-2 p-2">
                                <label class="mt-2 fw-bold">Roles:</label>
                                <div class="mt-2 ms-3 fw-normal" *ngFor="let role of roles">
                                    <input type="checkbox" [value]="role.id" (change)="selectRoles($event, role.id)" [checked]="role.isSelected"> {{role.roleName}}
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="searchByUser" class="me-2">Search by User</label>
                                            <input type="text" class="form-control form-control-sm w-auto" id="searchByUser" [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" (ngModelChange)="searchByUser(searchTerm)">
                                        </div>
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-primary btn-sm ms-2" (click)="addToToAddress()">Add to "To Address"</button>
                                            <button type="button" class="btn btn-primary btn-sm ms-2" (click)="addToCCAddress()">Add to "Cc Address"</button>
                                        </div>
                                    </div>

                                    <div class="table-responsive" style="height: 620px; width: 100%;">
                                        <table class="table table-sm table-bordered table-striped" style="width: 100%;">
                                            <thead class="table-light">
                                                <tr>
                                                    <th scope="col" style="width: 5%;"></th>
                                                    <th scope="col" style="width: 95%;">Users</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let user of searchedUsers" [class.selected-row]="user.isSelected">
                                                    <td>
                                                        <input type="checkbox" [checked]="user.isSelected" (change)="selectUsers($event, user)">
                                                    </td>
                                                    <td>{{ user.userName }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Email Form Panel -->
                        <div class="col-6 p-2 bg-primary" style="--bs-bg-opacity: .2;">
                            <form [formGroup]="emailForm">
                                <label class="fw-bold mb-2">E-Mail</label>
                                <div class="border border-1 p-3">

                                    <!-- To -->
                                    <div class="mb-2 row">
                                        <label class="col-1 col-form-label">To:</label>
                                        <div class="col-11 d-flex">
                                            <textarea class="form-control" formControlName="emailTo" readonly rows="1" style="background-color: #d3d3d3; font-size: 0.875rem;"></textarea>
                                            <button class="btn btn-sm btn-primary m-2" (click)="clearToAddress()">Clear</button>
                                        </div>
                                    </div>

                                    <!-- Cc -->
                                    <div class="mb-2 row">
                                        <label class="col-1 col-form-label">Cc:</label>
                                        <div class="col-11 d-flex">
                                            <textarea class="form-control" formControlName="emailCc" readonly rows="1" style="background-color: #d3d3d3; font-size: 0.875rem;"></textarea>
                                            <button class="btn btn-sm btn-primary m-2" (click)="clearCCAddress()">Clear</button>
                                        </div>
                                    </div>

                                    <!-- Subject -->
                                    <div class="mb-2 row">
                                        <label class="col-2 col-form-label">Subject:</label>
                                        <div class="col-10">
                                            <textarea class="form-control" formControlName="emailSubject" readonly style="background-color: #d3d3d3; font-size: 0.875rem;"></textarea>
                                        </div>
                                    </div>

                                    <!-- Question -->
                                    <div class="mb-2 row">
                                        <label class="col-2 col-form-label">Question:</label>
                                        <div class="col-10">
                                            <textarea class="form-control" formControlName="emailQuestion" rows="4" style="background-color: #fff2cc; font-size: 0.875rem;"></textarea>
                                        </div>
                                    </div>

                                    <!-- Description -->
                                    <div class="mb-2 row">
                                        <label class="col-2 col-form-label">Description:</label>
                                        <div class="col-10">
                                            <div class="form-control" style="background-color: #d3d3d3; font-size: 0.875rem;">
                                                <div class="col-form-label-sm" *ngIf="schedule">SCHEDULE INFO</div>
                                                <div class="col-form-label-md" *ngIf="schedule">
                                                    <div>Loc: {{schedule.locCode}} | Period: {{schedule.scheduleBeginDate}} to {{schedule.scheduleEndDate}}</div>
                                                    <div>Customer: {{schedule.customerName}}</div>
                                                    <div>Destination: {{schedule.locationName}}</div>
                                                    <div>City: {{schedule.locationCity}}</div>
                                                    <div>Commodity: {{schedule.commodityCode}} | #Loads: {{schedule.loads}}</div>
                                                </div>

                                                <ng-container *ngIf="dispatch">
                                                    <div class="col-form-label-sm">DISPATCH INFO</div>
                                                    <div>Customer: {{dispatch?.customer?.customerName}}</div>
                                                    <div>Origin: {{dispatch.location.locationName}}</div>
                                                    <div>City: {{dispatch.location.city}}</div>
                                                    <div># Loads: {{dispatch.loads}} | Rate: {{dispatch.currency}} {{dispatch.rate}}/{{dispatch.rateUnitOfMeasure}}</div>
                                                    <div>Trucker: {{dispatch?.trucker?.customerName}}</div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Closing -->
                                    <div class="mb-2 row">
                                        <label class="col-2 col-form-label">Closing:</label>
                                        <div class="col-10">
                                            <textarea class="form-control" formControlName="emailClosing" rows="2" style="background-color: #fff2cc; font-size: 0.875rem;"></textarea>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end mt-3">
                                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 80px;" (click)="sendMail()">Send</button>
                                        <button type="button" #closeButton class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                                    </div>

                                    <div class="mt-2">
                                        <span *ngIf="response?.status == 'Success'" class="text-success">{{response?.message}}</span>
                                        <span *ngIf="response?.status == 'Error'" class="text-danger">{{response?.message}}</span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
